import React from 'react';
import { useTheme } from './theme-utils';
import { Theme } from '../theme';

/**
 * StyledComponentsIntegration
 *
 * This component provides the theme to styled-components components.
 * It should be used to wrap any component that uses styled-components
 * and needs access to the theme.
 *
 * It follows Module M7 (Integration Points) principles by providing a clear
 * integration point between our theme system and styled-components.
 */
interface StyledComponentsIntegrationProps {
  children: React.ReactNode;
}

// Extend Window interface to include our custom property
declare global {
  interface Window {
    __THEME_DATA__: Theme;
  }
}

export const StyledComponentsIntegration: React.FC<StyledComponentsIntegrationProps> = ({ children }) => {
  // Get the theme from our theme context
  const themeContext = useTheme();
  
  // Set the theme on the window object for styled-components to use
  // This is a fallback for components that don't have access to the ThemeProvider
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__THEME_DATA__ = themeContext.theme as unknown as Theme;
    }
  }, [themeContext.theme]);
  
  // Use a div wrapper instead of ThemeProvider to avoid TypeScript issues
  // The theme is already set on the window object
  return (
    <div>
      {children}
    </div>
  );
};

export default StyledComponentsIntegration;